import { render, staticRenderFns } from "./ApprovedLoans.vue?vue&type=template&id=c18f711e&scoped=true&"
import script from "./ApprovedLoans.vue?vue&type=script&lang=js&"
export * from "./ApprovedLoans.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedLoans.vue?vue&type=style&index=0&id=c18f711e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18f711e",
  null
  
)

export default component.exports